import { ImageName } from "@mcleod/images";
import { Button, Image, ImageProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./AbstractComponentDemoExamples";
import { LiveExampleComponents } from "../LiveExampleComponents";

export class DemoImageExamples extends AbstractComponentDemoExamples {
    protected override registerExamples() {
        super.registerExamples();
        this.registerPropertyExamples("busy", {
            examples: [
                {
                    value: true,
                    description: "An image that is busy displays the rotating spinner icon (commonly called the busy spinner)."
                },
                {
                    value: false,
                    props: {
                        imageName: ImageName.trailer
                    },
                    onCreate: (exampleComponents: LiveExampleComponents) => {
                        const buttonMakeBusy = new Button({
                            caption: "Make Example Image Busy",
                            width: 200,
                            backgroundColor: "primary",
                            color: "primary.reverse",
                            marginLeft: 15,
                            rowBreak: false,
                            onClick: () => {
                                const exampleImage = exampleComponents.liveComponent as Image;
                                exampleImage.busy = true;
                                buttonMakeBusy.enabled = false;
                                setTimeout(() => {
                                    exampleImage.busy = false;
                                    buttonMakeBusy.enabled = true;
                                }, 5000);
                            }
                        });
                        exampleComponents.liveComponent.rowBreak = false;
                        exampleComponents.livePanel.add(buttonMakeBusy);
                    },
                    description: "An image that becomes busy will revert to displaying its original image when it is no longer busy."
                }
            ]
        });
        this.registerPropertyExamples("transition", {
            examples: [
                {
                    value: Image.resolveTransitionValue(2000),
                    description: "The 'activateSlideout' image is displayed below.  Click the 'Rotate 45 Degrees' button to rotate the image 45 degrees (clockwise).  Because the transition property sets any 'transform' change to take 2 seconds, the change in rotation will take 2 seconds to complete.  The 'ease-in-out' property controls the style of the transition."
                }
            ],
            onCreate: (exampleComponents: LiveExampleComponents) => {
                const button = new Button({
                    caption: "Rotate 45 Degrees",
                    width: 200,
                    backgroundColor: "primary",
                    color: "primary.reverse",
                    marginLeft: 15,
                    onClick: () => {
                        const image = exampleComponents.liveComponent as Image;
                        image.rotation = (image.rotation ?? 0) + 45;
                    }
                });
                exampleComponents.liveComponent.rowBreak = false;
                exampleComponents.livePanel.add(button);
            }
        });
    }

    protected override get propsForAllExamples(): Partial<ImageProps> {
        return {
            ...super.propsForAllExamples,
            name: ImageName.activateSlideout
        };
    }
}
